import apiClient from './apiClient'

export default {
  async getInviteInfo({ id }: { id: string }) {
    const { data } = await apiClient.get('/public/link/overview', { params: { id } })
    return data
  },
}
